import { render } from "./PredictionMarkets.vue?vue&type=template&id=b2a20ada&scoped=true"
import script from "./PredictionMarkets.vue?vue&type=script&lang=js"
export * from "./PredictionMarkets.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b2a20ada"

export default script